import Vue from 'vue'
import App from './App.vue'
import router from './router'

//styles
import './assets/css/style.scss'

//polyfill 
require('intersection-observer');

import imageLoad from '../src/directives/image-load'
Vue.directive('image-load',imageLoad)

import { ObserveVisibility } from 'vue-observe-visibility'
Vue.directive('observe-visibility', ObserveVisibility)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// import VueLazyload from 'vue-lazyload'
// Vue.use(VueLazyload, {
//   observer: true,
//   observerOptions: {
//     rootMargin: '0px',
//     threshold: 0.7
//   }
// })

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
